<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-body">
		<!-- 				 -->
		<!-- Printer Selector -->
		<!-- 				 -->
		<div class="selector-item">
			<div>
				<label>Card Printer</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="PrinterSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedPrinter"
					(ngModelChange)="onPrinterChange($event)"
				>
					<option *ngFor="let r of lstPrinter" [ngValue]="r">{{ r.PrinterName }} - {{ r.ScanStation }}</option>
				</select>
			</div>
		</div>

		<!-- 		    		-->
		<!-- Template Selector  -->
		<!-- 			     	-->
		<div class="selector-item">
			<div>
				<label>Template Name</label>
			</div>

			<div style="margin-left: 10px" [style.display]="SelectedAudience == 2 ? 'block' : 'none'">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="StaffTemplateSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedStaffTemplate"
					(ngModelChange)="onStaffTemplateChange($event)"
				>
					<option *ngFor="let r of lstStaffTemplate" [ngValue]="r">
						{{ r.CardName }}
					</option>
				</select>
			</div>

			<div style="margin-left: 10px" [style.display]="SelectedAudience != 2 ? 'block' : 'none'">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="StudentTemplateSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedStudentTemplate"
					(ngModelChange)="onStudentTemplateChange($event)"
				>
					<option *ngFor="let r of lstStudentTemplate" [ngValue]="r">
						{{ r.CardName }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 		 	     -->
	<!-- Person Selector -->
	<!-- 			 	 -->
	<div style="margin-bottom: -30px">
		<caass-personselector
			[AudienceID]="1"
			[CanSwitchAudience]="true"
			[ShowAllSchools]="false"
			[MultiSelect]="QueueIsLocked == true ? false : true"
			[buttonMultiSelectProcessCaption]="'Add to Queue'"
		></caass-personselector>
	</div>

	<div class="lockout-body" [style.display]="QueueIsLocked == true ? 'block' : 'none'">
		<label class="lockout-message">{{ LockoutMessage }}</label>
	</div>	

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh Queue</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()" [disabled]="QueueIsLocked == true">Delete</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onSetPrinter()" [disabled]="QueueIsLocked == true">Set Printer</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onSetCard()" [disabled]="QueueIsLocked == true">Set Template</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onSetFee()" [disabled]="QueueIsLocked == true">Set Fee</button>
		<button class="btn btn-success" style="margin-left: 5px" (click)="onPrint()" [disabled]="QueueIsLocked == true">Print Card</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onCancelPrint() "[disabled]="QueueIsLocked == true">Cancel Print</button>
		<label style="margin-left: 10px">Default Fee: {{ DefaultFee | currency : "USD" }}</label>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total items in print queue: {{ lstPrintQueue.length }}&nbsp;&nbsp;&nbsp;&nbsp;(no filters)</label><br />
		<label>&#9900; Total items selected: {{ lstPrintQueueChecked.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		<div [style.display]="isExpressIDCardPrintingMode == true ? 'block' : 'none'">
			<label
				>&#9900; Running in (Express IDCard Printing) mode. This allows changing the Printer, Card or Fee on items with a status of Print
				Pending.</label
			><br />
		</div>
	</div>
</div>

<!-- 					  -->
<!-- Display PrintQ Items -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstPrintQueue"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		[(selection)]="lstPrintQueueChecked"
		[rowHover]="true"
		dataKey="IDPrintQueueID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<tr>
				<th style="width: 3rem">
					<!-- 				   -->
					<!-- Display When Busy -->
					<!-- 				   -->
					<div [style.display]="isBusy == true ? 'block' : 'none'">
						<img class="busy-img" src="assets/images/loading.gif" />
					</div>
				</th>

				<th style="text-align: right">
					<div class="p-d-flex">
						<button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="onClearFilters()"></button>
					</div>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="HasPhotoDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasPhoto
								[ngModel]="value"
								[options]="lstHasPhoto"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!-- No Way To Clear the LastName filter in code without breaking the filter, Don't filter LastName until PrimeNG fixes it -->
				<th>
					<!-- <p-columnFilter type="text" field="LastName"></p-columnFilter> -->
				</th>

				<th class="fixwidth-10">
					<p-columnFilter field="IsStaffDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsStaffDesc
								[ngModel]="value"
								[options]="lstPersonTypes"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="CardName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCardName
								[ngModel]="value"
								[options]="lstCardNames"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th [style.display]="isShowCardStock == true ? 'table-cell' : 'none'">
					<p-columnFilter field="IDCardStockDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIDCardStockDesc
								[ngModel]="value"
								[options]="lstCardStocks"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="PrinterName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrinterName
								[ngModel]="value"
								[options]="lstPrinterNames"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="IDPrintQueueStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIDPrintQueueStatusDesc
								[ngModel]="value"
								[options]="lstPrintQueueStatuses"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-06"></th>
				<!-- Fee space filler -->

				<th>
					<!-- Date space filler -->
					<div class="p-d-flex" [style.display]="isShowCardStock == false ? 'block' : 'none'">
						<button pButton label="Stock" class="p-button-outlined" icon="pi pi-plus-circle" (click)="ontoggleCardStock()"></button>
					</div>
					<div class="p-d-flex" [style.display]="isShowCardStock == true ? 'block' : 'none'">
						<button pButton label="Stock" class="p-button-outlined" icon="pi pi-minus-circle" (click)="ontoggleCardStock()"></button>
					</div>
				</th>
			</tr>

			<tr>
				<th style="width: 3rem">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="StaffStudentID">ID<p-sortIcon field="StaffStudentID"></p-sortIcon></th>
				<th pSortableColumn="HasPhoto" class="fixwidth-09">Photo<p-sortIcon field="HasPhoto"></p-sortIcon></th>
				<th pSortableColumn="LastName">Full Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="IsStaffDesc" class="fixwidth-10">Type<p-sortIcon field="IsStaffDesc"></p-sortIcon></th>
				<th pSortableColumn="CardName">Card Name <p-sortIcon field="CardName"></p-sortIcon></th>
				<th [style.display]="isShowCardStock == true ? 'table-cell' : 'none'" pSortableColumn="IDCardStockDesc">
					Card Stock <p-sortIcon field="IDCardStockDesc"></p-sortIcon>
				</th>
				<th pSortableColumn="PrinterName">Printer Name<p-sortIcon field="PrinterName"></p-sortIcon></th>
				<th pSortableColumn="IDPrintQueueStatusDesc">Status<p-sortIcon field="IDPrintQueueStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="ReprintFee" class="fixwidth-06">Fee<p-sortIcon field="ReprintFee"></p-sortIcon></th>
				<th pSortableColumn="StatusDT">Status Date<p-sortIcon field="StatusDT"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rPrintQueueItem>
			<tr [pSelectableRow]="rPrintQueueItem">
				<td>
					<div>
						<p-tableCheckbox [pSelectableRow]="rPrintQueueItem" [value]="rPrintQueueItem"></p-tableCheckbox>
					</div>
				</td>

				<td>
					<div>{{ rPrintQueueItem.StaffStudentID }}</div>
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-has-photo-check': rPrintQueueItem.HasPhoto,
								'pi-ban table-no-photo-check': !rPrintQueueItem.HasPhoto
							}"
						></i>
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.FirstName }}
						{{ rPrintQueueItem.LastName }}
					</div>
				</td>

				<td>
					<div class="fixwidth-10">
						{{ rPrintQueueItem.IsStaffDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-template">
						{{ rPrintQueueItem.CardName }}
					</div>
				</td>

				<td [style.display]="isShowCardStock == true ? 'table-cell' : 'none'">
					<div class="table-data-stock">
						{{ rPrintQueueItem.IDCardStockDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-printer">
						{{ rPrintQueueItem.PrinterName }}
					</div>
				</td>

				<td>
					<div
						[ngClass]="{
							'table-data-status-1': rPrintQueueItem.IDPrintQueueStatusID == 1,
							'table-data-status-2': rPrintQueueItem.IDPrintQueueStatusID == 2,
							'table-data-status-3': rPrintQueueItem.IDPrintQueueStatusID == 3,
							'table-data-status-4': rPrintQueueItem.IDPrintQueueStatusID == 4,
							'table-data-status-5': rPrintQueueItem.IDPrintQueueStatusID == 5
						}"
					>
						{{ rPrintQueueItem.IDPrintQueueStatusDesc }}
					</div>
				</td>

				<td>
					<div class="fixwidth-06" [style.display]="rPrintQueueItem.IsStaff == false ? 'block' : 'none'">
						{{ rPrintQueueItem.ReprintFee | currency : "USD" }}
					</div>
					<div class="fixwidth-06" [style.display]="rPrintQueueItem.IsStaff == true ? 'block' : 'none'">N/A</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.StatusDTDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						-->
<!-- Display When No Photos -->
<!-- 					    -->
<div style="padding: 20px" [style.display]="lstPrintQueue.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No items in print queue...</label>
</div>
